// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2zuRs","toggleWrap":"styles_toggleWrap__3NW7k","content":"styles_content__127TF","selectAreaCode":"styles_selectAreaCode__1Zq3H"};